import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function loadSection () {
  return import(/* webpackChunkName: "containers/Section" */ 'containers/Section')
}

export default function getSectionComponentRouteUtil (props) {
  if (SECTION || (SERVER && global.SECTION)) {
    const Component = require('containers/Section').default
    return <Component {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadSection}
        {...props}
      />
    )
  }
}
